import React, { ReactNode } from 'react';
import { connect } from 'react-redux';

import { Dispatch } from 'redux';
import compose from '../../../utils/components/#compose';
import withScope, { WithScopeProps } from '../../../hocs/redux/withScope';
import mapScopeToProps from '../../../utils/redux/mapScopeToProps';

type MapperSrc = string | string[] | Record<string, string | string[]> | (() => MapperSrc) | MapperSrc[];

export interface MapperProps<Values> {
  children: (props: Values) => ReactNode;
  /** The source of data. See [mapScopeToProps](/Core/Utils/Redux%20utils/mapScopeToProps) for the `src` prop format. */
  src: MapperSrc;
  cacheKey?: number | string;
}

interface MapperPropsInternalProps extends WithScopeProps<{}> {
  dispatch: Dispatch;
}

const Mapper = <Values, >({ src, dispatch, scope, store, children, ...props }: MapperProps<Values> & MapperPropsInternalProps) => (
  <>{children(props as Values) || null}</>
);

const mapStateToProps = <Values, >(state: object, { src, ...props }: MapperProps<Values>) => mapScopeToProps(src as string)(state, props);

const ConnectedMapper: <Values, >(
  props: MapperProps<Values>
) => React.ReactElement<MapperProps<Values>> = compose<any>(
  withScope,
  connect<any, any, any, any>(mapStateToProps),
)(React.memo(Mapper));

/**
 * @component
 */
export default ConnectedMapper;
